import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
// import { LoaderComponent } from "../../../Common/LoaderComponent";
import Swal from "sweetalert2";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const List = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [role, setRole] = useState(null);
  const [alert, setAlert] = useState(null);
  const [inputs, setInputs] = useState({ type: "finished_goods" });
  const [loading, setLoading] = useState(true);

  // Modal states
  const [showModal, setShowModal] = useState(false);
  const [selectedShape, setSelectedShape] = useState(null);
  const [statusValue, setStatusValue] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateAlert, setUpdateAlert] = useState(null);

  // const fetchData = () => {
  //   Http.get("/product-list/" + inputs.type).then((res) => {
  //     setReceiveData(res.data);
  //   });
  // };
  const fetchData = async () => {
    setLoading(true); // Start loading

    try {
      const resRole = await Http.get(`/staff-type-check`);
      setRole(resRole.data);
      console.log(resRole.data);
      let type = "finished_goods"; // Default value, will be overwritten by logic below
      if (["lab", "gstore", "depot"].includes(resRole.data)) {
        type = "raw_materials";
        setInputs({ type });
      } else if (["mechanical", "electrical"].includes(resRole.data)) {
        type = "spare_parts";
        setInputs({ type });
      } else if (resRole.data == "planning") {
        type = "finished_goods";
        setInputs({ type });
      }
      console.log(type);

      if (resRole.data === "lab" || resRole.data === "gstore") {
        const res = await Http.get(`/product-list/${type}?withPending`);
        setReceiveData(res.data);
      } else {
        const res = await Http.get(`/product-list/${type}`);
        setReceiveData(res.data);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false); // Stop loading regardless of the outcome
    }
  };

  function formatStatusText(text) {
    if (!text) return "";

    // Replace underscore with space
    let formatted = text.replace(/_/g, " ");

    // Make first word uppercase, keep the rest lowercase
    let parts = formatted.split(" ");

    return parts.join(" ");
  }

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const deleteData = (id, deleteApiUrl, showMsg) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.delete("/" + deleteApiUrl + "/" + id).then((res) => {
          setReceiveData(res.data);
          Swal.fire("Deleted!", showMsg + " has been deleted.", "success");
        });
      }
    });
  };

  const formSubmit = () => {
    setLoading(true); // Start loading
    Http.get("/product-list/" + inputs.type).then((res) => {
      setReceiveData(res.data);
      setLoading(false); // Stop loading after fetching data
    });
  };
  const cols = [
    { field: "code", header: "Code" },
    { field: "name", header: "Name" },
    // { field: "unit.name", header: "Unit" },
    // { field: "price", header: "Price" },
    // { field: "sku", header: "SKU" },
    // { field: "pack_size", header: "Pack Size" },
    // { field: "stock", header: "Stock" },
    // { field: "stockQty", header: "Stock" },
    // { field: "type", header: "Type" },
    {
      field: (row) => formatString(row?.type),
      header: "type", // Apply formatting directly to the header
    },
    { field: "department_art.name", header: "Department" },
    {
      field: (rowData) => {
        return formatStatusText(formatStatusText(rowData.status));
      },
      header: " Status ",
    },
  ];

  // Handle modal open
  const handleStatusUpdate = (rowData) => {
    setSelectedShape(rowData);
    setStatusValue(rowData.status || "");
    setShowModal(true);
    setUpdateAlert(null);
  };

  // Handle modal close
  const handleModalClose = () => {
    setShowModal(false);
    setSelectedShape(null);
    setStatusValue("");
    setUpdateAlert(null);
  };

  const actionTemplate = (item, deleteData, role) => {
    return (
      <td className="text-xs">
        {item.status == "on_test" && (
          <button
            className="btn btn-primary btn-sm me-1"
            onClick={() => handleStatusUpdate(item)}
            title="Update Status"
          >
            <i className="fa fa-edit"></i>
          </button>
        )}

        <Link
          to={"/view-product/" + item.id}
          className="btn btn-info btn-sm ms-1"
          title="View Product"
        >
          <i className="fa fa-list"></i>
        </Link>

        {(role === "gstore" || role === "depot") &&
          item.status === "pending" && (
            <Link
              to={"/approve-product/" + item.id}
              className="btn btn-success btn-sm ms-1"
              title="Approve Product"
            >
              <i className="fa fa-check"></i>
            </Link>
          )}

        <Link
          to={{ pathname: "/edit-product/" + item.id }}
          className="btn btn-primary btn-sm"
          title="Edit"
        >
          <i className="fa fa-pencil" aria-hidden="true"></i>
        </Link>
        {/* <button
          className="btn btn-danger btn-sm ms-1"
          onClick={() => deleteData(item.id, "product", "product")}
          title="Delete"
        >
          <i className="fa fa-trash"></i>
        </button> */}
      </td>
    );
  };

  // Function to format the field name
  function formatString(str) {
    return str
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
  }

  const handleStatusSubmit = async (e) => {
    e.preventDefault();
    if (!selectedShape) return;

    setIsUpdating(true);
    try {
      const response = await Http.put(`/product-status/${selectedShape.id}`, {
        status: statusValue,
      });

      if (response.status === 200) {
        setUpdateAlert({
          type: "success",
          message: "Status updated successfully!",
        });

        // Update the local data
        setReceiveData((prevData) =>
          prevData.map((item) =>
            item.id === selectedShape.id
              ? { ...item, status: statusValue }
              : item
          )
        );

        // Close modal after a short delay
        setTimeout(() => {
          handleModalClose();
        }, 1500);
      }
    } catch (error) {
      console.error("Update error:", error);
      setUpdateAlert({
        type: "error",
        message: error.response?.data?.message || "Failed to update status",
      });
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <div>
      <IsLogin></IsLogin>
      {/* <LoaderComponent /> */}
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All product</h5>
            {/* {!["gstore", "depot"].includes(role) && (
              <> */}

            {role === "lab" && (
              <Link to="/create-pending-product" className="btn btn-primary">
                <i className="fa fa-plus-square mg-r-6"></i> Raw Material
              </Link>
            )}
            {role !== "lab" && (
              <Link to="/create-product" className="btn btn-primary">
                <i className="fa fa-plus-square mg-r-6"></i> New
              </Link>
            )}
            {/* </>
            )} */}
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />
            {!["lab", "mechanical", "electrical"].includes(role) && (
              <div className="card pd-sm-40">
                <div className="row">
                  <div className="col-md-6 offset-md-3">
                    <div className="row">
                      <div className="col-lg">
                        <select
                          className="form-control"
                          name="type"
                          value={inputs.type}
                          onChange={handleChange}
                        >
                          {/* {role !== "planning" && (
                            <>
                            </>
                          )} */}
                          {(role === "gstore" || role === "depot") && (
                            <>
                              <option value="raw_materials">
                                Raw Materials
                              </option>
                              <option value="stationery">Stationery</option>
                              <option value="furniture">Furniture</option>
                              <option value="spare_parts">Spare Parts</option>
                            </>
                          )}

                          {(role === "electrical" || role === "mechanical") && (
                            <>
                              <option value="spare_parts">Spare Parts</option>
                            </>
                          )}
                          {role === "lab" && (
                            <option value="raw_materials">Raw Materials</option>
                          )}
                          {(role === "planning" || role == "sample") && (
                            <option value="finished_goods">
                              Finished Goods
                            </option>
                          )}
                        </select>
                      </div>
                      <div className="col-lg">
                        <button
                          className="btn btn-primary btn-block mg-b-10"
                          onClick={formSubmit}
                        >
                          <i className="fa fa-send mg-r-10"></i> Search
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="am-pagebody">
            <div className="card pd-20 pd-sm-40">
              {/* <h6 className="card-body-title mg-sm-b-30">Datatable</h6> */}
              {/* <div className="row">
                <div className="table-responsive p-0 pb-2">
                  <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0">
                    <thead>
                      <tr>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          S/N
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Code
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Name
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Unit
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Price
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          SKU
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Pack Size
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Stock
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Category
                        </th>
                        <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                          Status
                        </th>
                        <th
                          width="13%"
                          className="text-uppercase text-dark text-sm font-weight-bolder ps-2"
                        >
                          Action
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {receiveData.map((item, index) => (
                        <tr key={item.id}>
                          <td className="text-xs">{index + 1}</td>
                          <td className="text-xs">{item.code || ""}</td>
                          <td className="text-xs">{item.name || ""}</td>
                          <td className="text-xs">
                            {item.unit ? item.unit.name : ""}
                          </td>
                          <td className="text-xs">{item.price || ""}</td>
                          <td className="text-xs">{item.sku || ""}</td>
                          <td className="text-xs">{item.pack_size || ""}</td>
                          <td className="text-xs">{item.stockQty || ""}</td>
                          <td className="text-xs">
                            {item.category ? item.category.name : ""}
                          </td>
                          <td className="text-xs">{item.status || ""}</td>
                          <td className="text-xs">
                            <Link
                              to={{ pathname: "/edit-product/" + item.id }}
                              className="btn btn-primary btn-sm"
                              title="Edit"
                            >
                              <i
                                className="fa fa-pencil"
                                aria-hidden="true"
                              ></i>
                            </Link>
                            <button
                              className="btn btn-danger btn-sm ms-1"
                              onClick={() =>
                                deleteData(item.id, "product", "product")
                              }
                              title="Delete"
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div> */}
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
                actionTemplate={(item, deleteData) =>
                  actionTemplate(item, deleteData, role)
                } // Pass `role` here                deleteData={deleteData}
              />
            </div>
            {/* Status Update Modal */}
            {showModal && (
              <div
                className="modal fade show"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0,0,0,0.5)",
                }}
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Update Status</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={handleModalClose}
                        disabled={isUpdating}
                      ></button>
                    </div>
                    <form onSubmit={handleStatusSubmit}>
                      <div className="modal-body">
                        {updateAlert && (
                          <div
                            className={`alert alert-${
                              updateAlert.type === "success"
                                ? "success"
                                : "danger"
                            }`}
                          >
                            {updateAlert.message}
                          </div>
                        )}
                        <div className="mb-3">
                          <label htmlFor="statusInput" className="form-label">
                            Status
                          </label>
                          <select
                            id="statusInput"
                            className="form-select"
                            value={statusValue}
                            onChange={(e) => setStatusValue(e.target.value)}
                            required
                            disabled={isUpdating}
                          >
                            <option value="">Select Status</option>
                            <option value="active">Active</option>
                          </select>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleModalClose}
                          disabled={isUpdating}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={isUpdating || !statusValue}
                        >
                          {isUpdating ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Updating...
                            </>
                          ) : (
                            "Update Status"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
